import React from 'react';
import Icon from '../../../components/AppIcon';

const ComplianceStatusOverview = () => {
  const complianceData = [
    {
      id: 1,
      category: "EPA Regulations",
      percentage: 92,
      status: "compliant",
      totalRequirements: 25,
      completedRequirements: 23,
      color: "text-success",
      bgColor: "bg-success/10",
      icon: "Shield"
    },
    {
      id: 2,
      category: "OSHA Safety",
      percentage: 78,
      status: "warning",
      totalRequirements: 18,
      completedRequirements: 14,
      color: "text-warning",
      bgColor: "bg-warning/10",
      icon: "HardHat"
    },
    {
      id: 3,
      category: "Organic Certification",
      percentage: 100,
      status: "compliant",
      totalRequirements: 12,
      completedRequirements: 12,
      color: "text-success",
      bgColor: "bg-success/10",
      icon: "Leaf"
    },
    {
      id: 4,
      category: "State Licensing",
      percentage: 65,
      status: "critical",
      totalRequirements: 8,
      completedRequirements: 5,
      color: "text-error",
      bgColor: "bg-error/10",
      icon: "FileText"
    }
  ];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'compliant':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  const getCircumference = (percentage) => {
    const radius = 40;
    const circumference = 2 * Math.PI * radius;
    return circumference - (percentage / 100) * circumference;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 agricultural-shadow">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Compliance Status Overview</h3>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>Updated 5 min ago</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {complianceData?.map((item) => (
          <div key={item?.id} className={`p-4 rounded-lg border ${item?.bgColor} border-border/50`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-lg ${item?.bgColor} ${item?.color}`}>
                  <Icon name={item?.icon} size={20} />
                </div>
                <div>
                  <h4 className="font-medium text-foreground">{item?.category}</h4>
                  <p className="text-sm text-muted-foreground">
                    {item?.completedRequirements}/{item?.totalRequirements} requirements
                  </p>
                </div>
              </div>
              <Icon name={getStatusIcon(item?.status)} size={20} className={item?.color} />
            </div>

            <div className="flex items-center justify-between">
              <div className="relative w-20 h-20">
                <svg className="w-20 h-20 transform -rotate-90" viewBox="0 0 100 100">
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    stroke="currentColor"
                    strokeWidth="8"
                    fill="transparent"
                    className="text-muted/20"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    stroke="currentColor"
                    strokeWidth="8"
                    fill="transparent"
                    strokeDasharray={`${2 * Math.PI * 40}`}
                    strokeDashoffset={getCircumference(item?.percentage)}
                    className={item?.color}
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className={`text-lg font-semibold ${item?.color}`}>
                    {item?.percentage}%
                  </span>
                </div>
              </div>

              <div className="text-right">
                <div className={`text-2xl font-bold ${item?.color}`}>
                  {item?.percentage}%
                </div>
                <div className="text-sm text-muted-foreground capitalize">
                  {item?.status}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Overall Compliance Score</span>
          <div className="flex items-center space-x-2">
            <div className="w-32 bg-muted rounded-full h-2">
              <div 
                className="bg-success h-2 rounded-full transition-all duration-300"
                style={{ width: '84%' }}
              />
            </div>
            <span className="font-semibold text-success">84%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplianceStatusOverview;